import { InboxViewService } from './InboxViewService';
import { InboxData } from '../inboxViewSlice/types';
import { data } from './mockData';

export const InboxViewServiceImpl: InboxViewService = {
  getInboxData: async (): Promise<InboxData> => {
    // return axios
    //     .get<GoogleUserInfo>(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${accessToken}`, {
    //         headers: {
    //             Authorization: `Bearer ${accessToken}`,
    //             Accept: 'application/json'
    //         }
    //     })
    //     .then((user) => {
    //         return user.data;
    //     })
    return Promise.resolve(data);
  },
};
